var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBowtie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4969 14.6804C16.1242 13.9485 16.5 13.0157 16.5 11.9999C16.5 10.9841 16.1242 10.0515 15.4971 9.31954L19.3675 8.09858C20.6626 7.69004 22 8.60229 22 9.89419V14.1058C22 15.3977 20.6626 16.31 19.3675 15.9014L15.4969 14.6804Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50305 14.6804L4.63246 15.9014C3.33739 16.31 2 15.3977 2 14.1058V9.89419C2 8.60229 3.33739 7.69004 4.63245 8.09858L8.5029 9.31954C7.87576 10.0515 7.5 10.9841 7.5 11.9999C7.5 13.0157 7.87582 13.9485 8.50305 14.6804Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowtie);
export default __webpack_public_path__ + "static/media/bowtie.d0e85ef1fcfa58f866f8f5227899c8f4.svg";
export { ForwardRef as ReactComponent };